import SectionLabel from "../../../components/SectionLabel";

export default function Narrative({ paragraphs }) {
    return (
        <section className="bg-[#15161A] border-t border-[rgba(201,168,106,0.12)] overflow-hidden">
            <div className="shell py-20 md:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
                    <div className="lg:col-span-4">
                        <SectionLabel number="04" label="Detailed Narrative" />
                        <h2 className="mt-8 font-serif text-3xl md:text-4xl leading-[1.1]">
                            In the{" "}
                            <span className="italic text-[#C9A86A]">
                                composer&rsquo;s hand.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-8 space-y-7 text-[#F3EFE7] text-lg leading-[1.85]">
                        {paragraphs.map((p, i) => (
                            <p
                                key={`narrative-${p.slice(0, 40)}`}
                                data-testid={`private-narrative-${i}`}
                            >
                                {p}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
